import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, filter, of} from 'rxjs';
import {HeaderEnum} from '../../enums/routes-header.enum';
import {RoutingEnum} from '../../enums/routing.enum';
import {getEnumKeyByEnumValue} from '../../utils/enumKeyByValue';
import {SessionStorageService} from '../session-storage/session-storage.service';
import {TranslationEnum} from '../../enums/translation.enum';
import {MotorQuoteDTO} from '../../models/MotorQuoteDTO.interfaces';

@Injectable({
  providedIn: 'root',
})
export class PageTypeService {
  private _postRequestData: Record<string, unknown> | null = null;
  private _typePage$: BehaviorSubject<keyof typeof HeaderEnum> = new BehaviorSubject<
    keyof typeof HeaderEnum
  >('homepage');
  get typePage$() {
    this._retriveTypePageFromStorage();

    return this._typePage$.asObservable();
  }

  constructor(private sessionStorageService: SessionStorageService) {}
  setTypePage(value: keyof typeof HeaderEnum) {
    this._typePage$.next(value);
    this.sessionStorageService.set('fq-page-type', this._typePage$.value);
  }

  getTypePage() {
    this._retriveTypePageFromStorage();
    return this._typePage$.value;
  }

  getSpecificPageRoute() {
    const pageType: keyof typeof HeaderEnum =
      getEnumKeyByEnumValue(HeaderEnum, this.getTypePage()) ?? TranslationEnum.HOMEPAGE;
    return RoutingEnum[pageType as keyof typeof RoutingEnum];
  }

  setPostRequestData(postData: Record<string, unknown>) {
    this._postRequestData = postData;
  }
  getPostRequestData(): Observable<Record<string, unknown> | null> {
    return of(this._postRequestData);
  }

  private _retriveTypePageFromStorage() {
    const storedTypePage = this.sessionStorageService.get('fq-page-type');
    if (storedTypePage) {
      this._typePage$.next(storedTypePage);
    }
  }

  overridePageTypeFromMotor(motorData: MotorQuoteDTO) {
    if (motorData.response.plans[0].uuid == '45') {
      this.setTypePage(TranslationEnum.ENERGIA);
      return;
    }
    this.setTypePage(TranslationEnum.HOMEPAGE);
  }
}
